


import {z} from "zod";
import { Harm } from "../Harm";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";
import { RiskRanksWithNA } from "../Risk";


const _HarmZod = z.object({
  harmRank: z.enum(RiskRanksWithNA).default("n/a"),
  description: z.string().default("")
})

// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _HarmZod, Harm>);

export const HarmSchema = _HarmZod.transform((data) => new Harm(data));


